import gtmService from './gtmService';
import {
  GTM_EVENT_TYPES,
  GTM_EVENT_COMPONENT_ID,
  GTM_EVENT_CATEGORY,
  GTM_EVENT_ACTION,
} from './constants';
import { TOOL_TYPE_COMPONENT } from '../../pluginServices/dragState/constants';

export function gtmTrackAuthoringPublicationUserInteraction(data) {
  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload:{
      ...data,
      componentId: GTM_EVENT_COMPONENT_ID.AUTHORING_PUBLICATION,
    },
  });
}

export function gtmTrackAuthoringCourseContentUserInteraction(data) {
  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload:{
      ...data,
      componentId: GTM_EVENT_COMPONENT_ID.AUTHORING_COURSE_CONTENT,
    },
  });
}

export function gtmTrackAuthoringDashboardUserInteraction(data) {
  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload:{
      ...data,
      componentId: GTM_EVENT_COMPONENT_ID.AUTHORING_DASHBOARD,
    },
  });
}

export function gtmTrackAuthoringScreenViewUserInteraction() {
  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload: {
      eventCategory: GTM_EVENT_CATEGORY.SCREEN_VIEW,
      eventAction: GTM_EVENT_ACTION.CLICK_SCREEN_FROM_LESSON_LIST,
      componentId: GTM_EVENT_COMPONENT_ID.AUTHORING_SCREEN_VIEW,
    },
  });
}

export function gtmTrackAuthoringSectionSettingsInteraction(data = {}) {
  const { changedData, editorLabel, screenId } = data;

  let eventAction = '';
  let eventLabel = null;
  let eventCategory = '';

  if (changedData && typeof changedData === 'object' && editorLabel === 'section') {
    if ('backgroundColor' in changedData) {
      eventAction = GTM_EVENT_ACTION.CLICK_BACKGROUND_COLOR_SELECTOR;
      eventCategory = GTM_EVENT_CATEGORY.SECTION_SETTINGS;
      eventLabel = changedData.backgroundColor ?? null;
    } else if ('rowsAreFullWidth' in changedData) {
      eventAction = GTM_EVENT_ACTION.TOGGLE_ROWS_FULL_WIDTH;
      eventCategory = GTM_EVENT_CATEGORY.SECTION_SETTINGS;
      eventLabel = changedData.rowsAreFullWidth;
    } else if ('cssClass' in changedData) {
      eventAction = GTM_EVENT_ACTION.KEYSTROKE_CSS_CLASS;
      eventCategory = GTM_EVENT_CATEGORY.SECTION_SETTINGS;
      eventLabel = changedData.cssClass ?? '';
    } else if ('conditionalContent' in changedData) {
      eventAction = GTM_EVENT_ACTION.CLICK_ADD_OUTPUT_TYPE;
      eventCategory = GTM_EVENT_CATEGORY.SECTION_SETTINGS;
      eventLabel = changedData.conditionalContent ?? null;
    }
  }

  if (eventAction && eventCategory && screenId) {
    gtmService.gtmTrackEvent({
      eventType: GTM_EVENT_TYPES.USER_INTERACTION,
      payload: {
        eventCategory,
        eventAction,
        eventLabel,
        componentId: GTM_EVENT_COMPONENT_ID.AUTHORING_SECTION_SETTINGS,
      },
    });
  }
}

export function gtmTrackAuthoringContentTocUserInteraction(data) {
  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload:{
      ...data,
      componentId: GTM_EVENT_COMPONENT_ID.AUTHORING_CONTENT_TOC,
    },
  });
}

export function gtmTrackAuthoringScreenUndoRedo(data) {
  const { type, sectionId } = data;
  let eventAction = GTM_EVENT_ACTION.CLICK_UNDO_REDO;
  let eventCategory = GTM_EVENT_CATEGORY.COMPONENT_TOOL;
  let componentId = GTM_EVENT_COMPONENT_ID.AUTHORING_SCREEN_VIEW;
  let eventLabel = type;

  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload: {
      eventAction,
      eventCategory,
      componentId,
      eventLabel,
      sectionId,
    },
  });
}

export function gtmTrackAuthoringScreenMenuSelection(data) {
  const { menuLabel, screenId } = data;
  let eventAction = GTM_EVENT_ACTION.SELECT_OPTION_FROM_SCREEN_MENU;
  let eventCategory = GTM_EVENT_CATEGORY.SECTION_CONTENT;
  let componentId = GTM_EVENT_COMPONENT_ID.AUTHORING_SCREEN_VIEW;
  let eventLabel = menuLabel;

  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload: {
      eventAction,
      eventCategory,
      componentId,
      eventLabel,
      screenId,
    },
  });
}

export function gtmTrackCodeBlockSelectionInteraction(data) {
  const { language, screenId, sectionId } = data;
  let eventAction = GTM_EVENT_ACTION.SELECT_CODE_BLOCK_COMPONENT;
  let eventCategory = GTM_EVENT_CATEGORY.COMPONENT_TOOL;
  let componentId = GTM_EVENT_COMPONENT_ID.AUTHORING_SCREEN_VIEW;
  let eventLabel = language;

  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload: {
      eventAction,
      eventCategory,
      componentId,
      eventLabel,
      screenId,
      sectionId,
      locationInApp: 'Screen > Component Tool > Code Block',
    },
  });
}

export function trackComponentInteraction(props, changedData) {
  const screenId = props?.match?.params?.screenId || props?.selectedWalkableId;
  const sectionId = props?.stageRef;
  const pluginName = props?.componentItem?.plugin?.name;

  if (!screenId || !changedData || typeof changedData !== 'object' || Object.keys(changedData).length === 0) {
    return;
  }

  const data = {
    language: changedData.language,
    screenId,
    sectionId,
  };
  if (pluginName === 'Code Block' && 'language' in changedData) {
    gtmTrackCodeBlockSelectionInteraction(data);
  }
}

export function gtmTrackComponentToolDrag(dragData) {
  if (!dragData) {
    return;
  }
  gtmService.gtmTrackEvent({
    eventType: GTM_EVENT_TYPES.USER_INTERACTION,
    payload: {
      eventCategory: GTM_EVENT_CATEGORY.COMPONENT_TOOL,
      eventAction:
        dragData.tool === TOOL_TYPE_COMPONENT
          ? GTM_EVENT_ACTION.DRAG_COMPONENT_TO_ADD
          : GTM_EVENT_ACTION.DRAG_TOOL_TO_ADD,
      eventLabel: dragData.pluginName || dragData.tool,
      componentId: GTM_EVENT_COMPONENT_ID.AUTHORING_SCREEN_VIEW,
      sectionId: null,
      assetId: null,
      assetType: null,
      assetSource: null,
    },
  });
}
